@if (column(); as column) {
  @if (model(); as model) {
    @switch (column.key) {
      @case (getColumnKey('status')) {
        <app-warehouse-restock-status [status]="model.status" />
      }

      @case (getColumnKey('type')) {
        <app-warehouse-restock-type [type]="model.type" />
      }

      @case (getColumnKey('orderNumber')) {
        @if (isNotNil(model.orderNumber)) {
          <div
            pTooltip="Kliknij, aby wyświetlić szczegóły"
            role="button"
            (click)="handleShowOrderDetailsClick()">
            <div class="text-[#3858E9] underline decoration-dotted">
              {{ model.orderNumber }}
            </div>
          </div>
        } @else {
          <app-no-data />
        }
      }

      @default {
        <app-table-body-no-reference-cell [columnKey]="column.key" />
      }
    }
  }
}
